
import React from 'react';
import {useNavigate} from 'react-router-dom';
//import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

//function handleRegisterClick(){
    // Logic for handling registration click
    // onClick={handleRegisterClick()}
//    console.log("Register button clicked"); 
//
//}

export function Usuario(){

    const navigate = useNavigate();

    function HandleRegisterHereClick(){

        console.log("Register button clicked");
        navigate('/register'); // Navigate to the registration page
        
    }
    
    return(
        <div style={{ textAlign: 'center', padding: '40px 20px', maxWidth: '600px', margin: '0 auto' }}>
            <span className='Usuario'>
                Welcome to MountainBike Costa Rica. Please register to continue.
                <button onClick={HandleRegisterHereClick}>Register here</button>
            </span>

        </div>
    );
}
